import React from 'react';
import { FaGlobeAmericas } from 'react-icons/fa';

interface InternationalOrderIconProps {
  readonly className?: string;
}

function InternationalOrderIcon({ className }: InternationalOrderIconProps): React.ReactElement {
  return (
    <FaGlobeAmericas
      className={className}
      role="img"
      aria-label="International order"
    />
  );
}

export default InternationalOrderIcon;
